import {Card} from "../../../../../../../../components/card/card.jsx";
import DashCard from "../../../../../../../../components/dash-card/dash-card.jsx";
import MetricDashCard from "../../../../../../../../components/dash-card/metric-dash-card.jsx";
import TypeActions from "./type-actions.jsx";
import ActionsHeatmap from "./actions-heatmap.jsx";

export default function AttendanceCard({ data }) {
    const actions = data?.actions?.total;

    return (
        <Card className="dash-main-card col-span-3 row-span-2 h-full">
            <Card.Header className="border-b-0! bg-transparent!">
                <Card.Title className="bg-transparent text-[#F4FFFF] text-center translate-y-1.5 w-full text-(length:--font-lg)!">
                    Atendimentos e acompanhamentos
                    <p className="font-light"> Últimos 7 dias</p>
                </Card.Title>
            </Card.Header>
            <Card.Body className="flex-1 min-h-0 flex px-(--dash-pad-md)! pb-(--dash-pad-md)!">
                <DashCard width="100%" height="100%" className="h-full min-h-0">
                    <section className="h-full grid grid-rows-[0.8fr_1fr_2.2fr] gap-(--dash-pad-md) justify-center">
                        <MetricDashCard
                            diagonal
                            diagonalCounter
                            title="Ações desempenhadas"
                            value={actions ?? 0}
                            width={225}
                            height={86}
                            dashClassName="min-w-0 mt-4 justify-self-center"
                            pClassName="leading-[1.15]!"
                        />
                        <TypeActions data={data} />
                        <ActionsHeatmap data={data?.actions?.heatmap ?? []} />
                    </section>
                </DashCard>
            </Card.Body>
        </Card>
    )
}
